import React from 'react';
import { Box, Container, Typography, Card, CardContent } from '@mui/material';
import { Helmet } from "react-helmet";

const Programme = () => (
    <Box sx={{ position: 'relative', minHeight: '100vh', py: 4, overflow: 'hidden' }}>
        <Helmet>
            <link
                rel="preload"
                as="image"
                href="https://dcfcn9te0xk7k.cloudfront.net/cm2c/la-batucada-de-chalamont-etait-accompagnee-par-les-danseuses-de-samba-photo-catherine-aulaz.jpg"
            />
        </Helmet>
        <Box
            component="img"
            src="https://dcfcn9te0xk7k.cloudfront.net/cm2c/la-batucada-de-chalamont-etait-accompagnee-par-les-danseuses-de-samba-photo-catherine-aulaz.jpg"
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                opacity: 0.3,
                zIndex: -1,
            }}
        />

        <Container maxWidth="xl">
            <Card sx={{ borderRadius: 2, boxShadow: 2, bgcolor: 'rgba(255, 255, 255, 0.9)', p: 3 }}>
                <CardContent>
                    <Typography variant="h4" align="center" gutterBottom sx={{ color: "#d62121", fontWeight: 'bold' }}>
                        Merci à toutes et à tous !
                    </Typography>
                    <Typography variant="body1" align="center" sx={{ my: 3, fontSize: '1.2rem' }}>
                        La Fête du Muguet 2025 s'est terminée en beauté, grâce à vous. Un immense merci à toutes celles et ceux qui ont contribué à rendre ce moment inoubliable : bénévoles, associations, artistes et bien sûr vous, cher public !
                    </Typography>
                    <Typography variant="body1" align="center" sx={{ my: 3, fontSize: '1.2rem' }}>
                        Nous vous donnons déjà rendez-vous en 2026, pour encore plus de joie, de convivialité et de belles festivités à Chalamont.
                    </Typography>
                    <Typography variant="h6" align="center" sx={{ color: "#d62121", mt: 4 }}>
                        À l'année prochaine !
                    </Typography>
                </CardContent>
            </Card>
        </Container>
        <Container maxWidth="xl" sx={{ mt: 4 }}>
            <Card sx={{ borderRadius: 2, boxShadow: 1, bgcolor: 'rgba(255, 255, 255)', p:2 }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 5,
                    }}
                >
                    {[
                        'https://dcfcn9te0xk7k.cloudfront.net/cm2c/logo_CM2C.jpg',
                        'https://dcfcn9te0xk7k.cloudfront.net/cm2c/Blason_ville_fr_Chalamont.svg',
                        'https://dcfcn9te0xk7k.cloudfront.net/cm2c/Logo_CC_Dombes.svg',
                        'https://dcfcn9te0xk7k.cloudfront.net/cm2c/Logo_Ain_2018.svg',
                        'https://dcfcn9te0xk7k.cloudfront.net/cm2c/auvergne_rhone_alpes.svg',
                        'https://dcfcn9te0xk7k.cloudfront.net/cm2c/Logo_Groupama_-_2016.svg',
                        'https://dcfcn9te0xk7k.cloudfront.net/cm2c/credit_agricole.svg',
                    ].map((src, index) => (
                        <Box
                            key={index}
                            component="img"
                            src={src}
                            alt={`logo-${index}`}
                            sx={{
                                height: { xs: 50, sm: 60 },
                                objectFit: 'contain',
                                maxWidth: '100px',
                                flexShrink: 0,
                            }}
                        />
                    ))}
                </Box>
                <Box>
                    <Typography color={"#888888"} fontSize={"0.6em"} variant="p">
                        ©Photo : Catherine Aulaz
                    </Typography>
                </Box>
            </Card>
        </Container>
    </Box>
);

export default Programme;